/** A highlighted area of a screenshot, in percent of the image (0–100). */
export type FocusBox = { left: number; top: number; width: number; height: number }

export type GuideStepContent = {
  title: string
  text: string
  /** A side case set apart from the main text, drawn as a callout under it. */
  note?: { title: string; text: string }
  image?: string
  imageAlt?: string
  /** What the text is talking about, drawn as a ring over the screenshot. */
  focus?: FocusBox[]
}

/** Turns two corner points, measured on an image of `width`×`height` pixels, into percentages. */
export const makeBox =
  (width: number, height: number) =>
  (x1: number, y1: number, x2: number, y2: number): FocusBox => ({
    left: (x1 / width) * 100,
    top: (y1 / height) * 100,
    width: ((x2 - x1) / width) * 100,
    height: ((y2 - y1) / height) * 100,
  })

/** The install and login screenshots were measured at 923×2000. */
export const box = makeBox(923, 2000)
